import React from "react";
import BikersList from "./bikersList";
import { Switch, Route } from "react-router-dom";
import NewBikerForm from "./newBikerForm";
import EditBikerForm from "./editBikerForm";

function Bikers() {
  return (
    <div>
      <Switch>
        <Route exact path="/store/:storeId/bikers" component={BikersList} />
        <Route path="/store/:storeId/bikers/new" component={NewBikerForm} />
        <Route path="/store/:storeId/bikers/edit/:bikerId" component={EditBikerForm} />
      </Switch>
    </div>
  );
}

export default Bikers;
